module.exports = __webpack_public_path__ + "static/media/sn.1569aca0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sn.svg
// module id = 1159
// module chunks = 0